import { call, put, select, takeLatest } from 'redux-saga/effects'
import { DRAW_PRIZE } from './constants';
import { endDrawPrize } from './actions';
import gameTurnService from '../services/gameTurn';
import { handleUpdateGame } from '../ActiveGame/sagas';
import { selectActiveGame } from '../ActiveGame/selectors';
import { closeContextMenu } from '../ActiveGame/actions';

function* drawPrizeTask(action) {
  const gameId = (yield select(selectActiveGame)).get('id');
  const game = yield call(gameTurnService.drawPrize, gameId, action.payload.get('prizePosition'));

  yield call(handleUpdateGame, game);

  yield put(endDrawPrize());

  // The hand is always on screen, so the new card shows there.
  yield put(closeContextMenu());
}

function* drivePrizeWatcher() {
  yield takeLatest(DRAW_PRIZE, drawPrizeTask);
}

export default [
  drivePrizeWatcher,
];
